module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-11.e059c5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-11.jpg
// module id = A+IF
// module chunks = 52